import { render, staticRenderFns } from "./TemplateConfigForm.vue?vue&type=template&id=683a2a40&"
import script from "./TemplateConfigForm.vue?vue&type=script&lang=js&"
export * from "./TemplateConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports